export default "__VITE_ASSET__BiCrRsWd__"